<template>
  <div style="display: inline">
    <!-- table表格 -->
    <el-form :inline="true" ref="form" size="mini" :model="form" :label-width="yt.formLabelWidth" style="margin-top: 20px">
      <el-form-item class="noborder" :label="$t('danjuleixing')" required>
        <el-select disabled v-model="$attrs.check.type" @change="$forceUpdate()">
          <el-option :label="$t('shengchanruku')" :value="2"></el-option>
          <el-option :label="$t('tuihuoruku')" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="noborder" :label="$t('rukudanhao')">
        <el-input disabled v-model="$attrs.check.no"></el-input>
      </el-form-item>
      <el-form-item class="noborder" :label="$t('beizhu')">
        <el-input disabled v-model="$attrs.check.remark"></el-input>
      </el-form-item>
      <el-form-item>
        <yi_curd_expand_button></yi_curd_expand_button>
      </el-form-item>
    </el-form>
    <!-- 批量入库按钮 -->
    <el-button size="mini" @click="quickWrite()" style="margin-bottom: 16px;margin-top: 16px"
        type="primary">
      {{$t('yijiantianxiebencishishou')}}
    </el-button>


      <el-table class="tables" :data="form.inOrderDetailList"
          :header-cell-style="{background: '#F5F7FA',color:'#606266','font-weight':'700','font-size':'14px', height:'48px', padding:'0px'}"
          :show-overflow-tooltip="true" size="mini" border stripe max-height="500" style="width: 100%">

        <el-table-column prop="materialName" :label="$t('wuliaobianmamingcheng')" width="150"
            :show-overflow-tooltip="true">
          <template slot-scope="scope">
              <span>{{scope.row.material.code}}/{{scope.row.material.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="materialBatchNo" :label="$t('chanpinpicihao')" width="150"
            :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.materialBatchNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="woNo" :label="$t('shengchangongdanhao')" width="150"
            :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.woNo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unit" :label="$t('danwei')" width="150"
            :show-overflow-tooltip="true">
          <template slot-scope="scope">
              <span> {{$t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.unit])}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="dueQuantity" :label="$t('weishoushuliang')" width="150"
            :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.dueQuantity}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="newReceiveQuantity" :label="$t('bencishishou')" width="176">
          <template slot-scope="scope">
            <el-input-number  size="mini"
                v-model="scope.row.newReceiveQuantity" :controls="false" class="input" >
            </el-input-number>
          </template>
        </el-table-column>

        <el-table-column prop="warehouseId" :label="$t('cangkubianma/mingcheng')" width="206">
          <template slot-scope="scope" >
            <yi_cross_select :max="1" :selectTitle="'code,name'"
                :component="'web_wms_purchase_receipt_check_warehouse_code'"
                :ids.sync="scope.row.warehouseId" @getItems="(val)=>{getItems(val, scope)}" class="input">
            </yi_cross_select>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseAreaId" :label="$t('kuqubianma/mingcheng')" width="206">
          <template slot-scope="scope">
            <yi_cross_select  v-if="scope.row.isShowAreaCode!==false"  :disabled="scope.row.warehouseId == null" :warehouseId="scope.row.warehouseId" :max="1" :selectTitle="'code,name'"
                :component="'web_wms_purchase_receipt_check_warehouse_area_code'"
                :ids.sync="scope.row.warehouseAreaId" @getItems="(val)=>{getItem(val, scope)}">
            </yi_cross_select>
          </template>
        </el-table-column>
        <el-table-column prop="warehouseLocationId" :label="$t('kuweibianma/mingcheng')" width="206">
          <template slot-scope="scope">
            <yi_cross_select  v-if="scope.row.isShowLocation!==false" :disabled="scope.row.warehouseAreaId == null" :areaId="scope.row.warehouseAreaId" :max="1" :selectTitle="'code,name'"
                :component="'web_wms_purchase_receipt_check_warehouse_location_code'"
                :ids.sync="scope.row.warehouseLocationId">
            </yi_cross_select>
          </template>
        </el-table-column>


<!--        <el-form-item :label="$t('cangkubianma/mingcheng')" required>
          <yi_cross_select :max="1" :selectTitle="'code,name'"
              :component="'web_wms_purchase_receipt_check_warehouse_code'"
              :ids.sync="scope.row.warehouseId" @getItems="getItems">
          </yi_cross_select>
        </el-form-item>
        <el-form-item :label="$t('kuqubianma/mingcheng')">
          <yi_cross_select v-if="isShowAreaCode" :disabled="warehouseAreaIdDisabled" :warehouseId="this.warehouseId" :max="1" :selectTitle="'code,name'"
              :component="'web_wms_purchase_receipt_check_warehouse_area_code'"
              :ids.sync="scope.row.warehouseAreaId" @getItems="getItem">
          </yi_cross_select>
        </el-form-item>
        <el-form-item :label="$t('kuweibianma/mingcheng')">
          <yi_cross_select v-if="isShowLocation"  :disabled="warehouseLocationIdDisabled" :areaId="this.areaId" :max="1" :selectTitle="'code,name'"
              :component="'web_wms_purchase_receipt_check_warehouse_location_code'"
              :ids.sync="scope.row.warehouseLocationId">
          </yi_cross_select>
        </el-form-item>-->




      </el-table>

  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_wms_in_order_product_check_batch_put_in',
  components: {},
  data() {
    return {
      warehouseAreaIdDisabled: true,
      warehouseLocationIdDisabled: true,
      planCodeList: [],
      warehouseId: null,
      areaId: null,
      show: false,
      isShowAreaCode:true,
      isShowLocation:true,
      exceptionTypeList: [],
      form: {
        // id:'',
        ...this.$attrs.check,
        inOrderDetailList: [],
      },
    };
  },
  created() {
    this.listDetail();
  },
  mounted() {
  },
  watch: {
    /*'isShowAreaCode': {
      handler(n) {
        if (n==false) {
          console.log('hhhhhhhhhhhhhhh',n)
          this.warehouseAreaIdDisabled = false
        }
      },
      immediate: false,
      deep: true
    },
    'isShowLocation': {
      handler(n) {
        if (n==false) {
          console.log('hhhhhhhhhhhhhhh',n)
          this.warehouseLocationIdDisabled = false
        }
      },
      immediate: false,
      deep: true
    },*/
  },
  methods: {
    async listDetail() {
      let response = await this.http.get('/web/in/order/detail/page', {
        params: {
          inOrderId: this.$attrs.check.id,
          pageNum: 1,
          pageSize: 1000
        },
      })
      for (var i = 0; i < response.data.rows.length; i++) {
        let detail = response.data.rows[i];
        detail.isShowAreaCode=true
        detail.isShowLocation=true
        if (detail.dueQuantity !== 0) {
          this.form.inOrderDetailList.push(detail);
        }
      }
    },
    getItems(checks,scope) {
      //重置第二个选择框
      scope.row.isShowAreaCode = false
      scope.row.warehouseAreaId = null
      scope.row.warehouseLocationId = null
      this.$nextTick(()=>{
        scope.row.isShowAreaCode = true
        console.log("isShowAreaCode",scope.row.isShowAreaCode)
      })

    },

    getItem(checks,scope) {
      // isShowLocation
      //this.areaId = checks.id
      scope.row.isShowLocation = false
      scope.row.warehouseLocationId = null
      this.$nextTick(()=>{
        scope.row.isShowLocation = true
      })
    },
    quickWrite(){
      console.log('quickWrite', this.form.inOrderDetailList )
      for (var i = 0; i < this.form.inOrderDetailList.length; i++) {
        /*let eq = {}
        eq.equipmentId = params.equipmentIds[i];
        eq.mouldId = params.mouldId;
        eq.sort = params.sort;
        paramsList.push(eq)*/
        let detail = this.form.inOrderDetailList[i];
        detail.newReceiveQuantity = detail.dueQuantity;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.dialog /deep/ .el-dialog__body {
  overflow: auto;
}

.input /deep/ .el-input__inner {
  width: 150px;
}

.input1 /deep/ .el-input__inner {
  width: 220px;
}

.input3 /deep/ .el-input__inner {
  width: 200px;
  text-align: left;
}
</style>
